
import { Component, Prop, Vue } from "vue-property-decorator";
import UsersTable from "@/components/user/UsersTable.vue";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import UserDetail from "@/components/user/UserDetail.vue";
import AddServicepointForm from "@/components/user/AddServicepointForm.vue";
import { Action, Getter } from "vuex-class";
import { ICountryConfigResponse, ISolResponse, IUpdateUser, IUser, IUserDetail } from "@/entities";
import { i18n } from "@/i18n";
import UserServicepointsTable from "@/components/user/UserServicepointsTable.vue";
import UserServicepointsApprovalsTable from "@/components/user/UserServicepointsApprovalsTable.vue";
import AsyncComputed from "vue-async-computed-decorator";

@Component({
  name: "user-edit-page",
  components: {
    UserServicepointsTable,
    UserServicepointsApprovalsTable,
    AddServicepointForm,
    UsersTable,
    IconTrash,
    UserDetail,
  },
  props: ["id"],
})
export default class UserEditPage extends Vue {
  @Prop() public id!: number;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Action("fetchUserDetail") fetchUserDetail!: (idUser: number) => Promise<IUserDetail | undefined>;
  @Action("updateUser") updateUser!: ({
    idUser,
    updateUser,
  }: {
    idUser: number | undefined;
    updateUser: IUpdateUser | undefined;
  }) => Promise<ISolResponse | undefined>;

  user: IUserDetail | undefined | null = null;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    await this.fetchUser(+this.$route.params.id);
  }

  async fetchUser(userId: number): Promise<void> {
    this.user = await this.fetchUserDetail(userId);
  }

  async synchronize(): Promise<void> {
    if (this.user?.id) {
      const response = await this.$services.user.syncUser(this.user.id);
      if (response) {
        this.makeToast("success", i18n.t("validation.messages.user.ok").toString());
        await this.fetchUser(this.user.id);
      } else {
        this.makeToast("warning", i18n.t("validation.messages.user.ko").toString());
      }
    }
  }

  @AsyncComputed()
  async config(): Promise<ICountryConfigResponse | undefined> {
    if (this.user?.country?.code) {
      return this.$services.country.getCountryConfigByCode(this.user.country.code);
    }
    return {};
  }

  get showSynchronize(): boolean {
    return (
      (!this.user?.solSynchronized &&
        (this.user?.username !== this.loggedUser?.username || this.loggedUser?.admin)) ||
      false
    );
  }

  makeToast(variant: string, message: string): void {
    this.$bvToast.toast(message, {
      autoHideDelay: 4000,
      variant,
      toaster: "b-toaster-bottom-center",
      noCloseButton: true,
    });
  }
}
